// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --ion-background-color: #292938;
}

h6 {
  color: var(--ion-color-light);
}

@media screen and (max-width: 576px) {
  iframe {
    width: 100%;
    height: auto;
    min-height: 88%;
    max-height: 88%;
    overflow: auto;
  }
}
@media screen and (max-width: 992px) and (orientation: landscape) {
  iframe {
    width: 100%;
    height: 95% !important;
    min-height: 88%;
    max-height: 95%;
    overflow: auto;
  }
}
.netPositionBar {
  padding: 0 10px 0 10px;
  height: 30px;
  align-items: center;
  justify-content: center;
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0);
  border-radius: 5px;
  margin: 5px;
  color: white;
  background-color: black;
}

.mobileweb-landscape-header {
  background-color: var(--ion-color-secondary);
  display: none;
}
@media screen and (max-width: 992px) and (orientation: landscape) {
  .mobileweb-landscape-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 2rem;
    gap: 2rem;
    font-weight: bold;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/tabs/tab-livedealer/tab-livedealer.page.scss"],"names":[],"mappings":"AAAA;EACI,+BAAA;AACJ;;AAEA;EACI,6BAAA;AACJ;;AAEA;EAEI;IACI,WAAA;IACA,YAAA;IACA,eAAA;IACA,eAAA;IACA,cAAA;EAAN;AACF;AAGA;EAEI;IACI,WAAA;IACA,sBAAA;IACA,eAAA;IACA,eAAA;IACA,cAAA;EAFN;AACF;AAKA;EACI,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,4CAAA;EACA,aAAA;AAHJ;AAII;EAHJ;IAIQ,aAAA;IACA,2BAAA;IACA,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,iBAAA;EADN;AACF","sourcesContent":["ion-content {\n    --ion-background-color: #292938;\n}\n\nh6 {\n    color: var(--ion-color-light);\n}\n\n@media screen and (max-width: 576px) {\n\n    iframe {\n        width: 100%;\n        height: auto;\n        min-height: 88%;\n        max-height: 88%;\n        overflow: auto;\n    }\n}\n\n@media screen and (max-width: 992px) and (orientation: landscape) {\n\n    iframe {\n        width: 100%;\n        height: 95% !important;\n        min-height: 88%;\n        max-height: 95%;\n        overflow: auto;\n    }\n}\n\n.netPositionBar{\n    padding: 0 10px 0 10px;\n    height: 30px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    border: 1px solid #ffffff00; \n    border-radius: 5px;\n    margin: 5px;\n    color: white;\n    background-color: black;\n}\n\n.mobileweb-landscape-header{\n    background-color: var(--ion-color-secondary);\n    display: none;\n    @media screen and (max-width: 992px) and (orientation: landscape) {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        padding-left: 2rem;\n        gap: 2rem;\n        font-weight: bold;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
